import http from '../getData';
import {getUser} from '../common';

export default {
    SaveContract(params) {
        if (getUser(params)) {
            return http.post('SaveContract', getUser(params));
        }
    },
    SaveContractPay(params) {
        if (getUser(params)) {
            return http.post('SaveContractPay', getUser(params));
        }
    },
    GetContract(params) {
        if (getUser(params)) {
            return http.post('GetContract', getUser(params));
        }
    },
    PayStatusChange(params) {
        if (getUser(params)) {
            return http.post('PayStatusChange', getUser(params));
        }
    },
    GetLog(params) {
        if (getUser(params)) {
            return http.post('GetLog', getUser(params));
        }
    },
    GetContractPayShenheLog(params) {
        if (getUser(params)) {
            return http.post('GetContractPayShenheLog', getUser(params));
        }
    },
    SaveConstruction(params) {
        if (getUser(params)) {
            return http.post('SaveConstruction', getUser(params));
        }
    },
    SaveConstructionUser(params) {
        if (getUser(params)) {
            return http.post('SaveConstructionUser', getUser(params));
        }
    },
    GetConstruction(params) {
        if (getUser(params)) {
            return http.post('GetConstruction', getUser(params));
        }
    },
    WaitShenheProject(params) {
        if (getUser(params)) {
            return http.post('WaitShenheProject', getUser(params));
        }
    },
    MyWait(params) {
        if (getUser(params)) {
            return http.post('MyWait', getUser(params));
        }
    },
    GetTopNum(params) {
        if (getUser(params)) {
            return http.post('GetTopNum', getUser(params));
        }
    },
    GetMyConstruction(params) {
        if (getUser(params)) {
            return http.post('GetMyConstruction', getUser(params));
        }
    },
    WaitPayProject(params) {
        if (getUser(params)) {
            return http.post('WaitPayProject', getUser(params));
        }
    }
};